module.exports = __webpack_public_path__ + "img/heart.604fe290.svg";